// Elite Relógios · compra pelo WhatsApp e menu no hover.

// Quando a variante muda, troca o botão de compra e a conversa sobre a peça pelo HTML novo (variante e preço certos na mensagem).
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data || !data.html) return;
    [`EliteWaBuy-${data.sectionId}`, `EliteConversa-${data.sectionId}`].forEach((id) => {
      const fresh = data.html.getElementById(id);
      const current = document.getElementById(id);
      if (fresh && current) current.replaceWith(fresh);
    });
  });
}

// Link marcado como indisponível não abre.
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('a[aria-disabled="true"]');
  if (link) event.preventDefault();
});

// No desktop, menu com filhos abre ao passar o mouse.
if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
  document.querySelectorAll('header-menu details, .header__inline-menu details').forEach((details) => {
    let timer;
    details.addEventListener('mouseenter', () => { clearTimeout(timer); details.setAttribute('open', ''); details.querySelector('summary')?.setAttribute('aria-expanded', 'true'); });
    details.addEventListener('mouseleave', () => { timer = setTimeout(() => { details.removeAttribute('open'); details.querySelector('summary')?.setAttribute('aria-expanded', 'false'); }, 120); });
  });
}
